import "./ChequeListCard.scss";
import { englishToNepaliAmountConverter } from "../../../utils/services";
import {
    CalenderIcon,
    DepositIcon,
    RevertIcon,
    ThreeDotsIcon,
} from "../../../assets/images/svg/svg";
import { Dropdown } from "react-bootstrap";

const ChequeListCard: React.FC<any> = ({
    document_number,
    cheque_no,
    miti,
    name,
    address = null,
    logo,
    mobile,
    amount,
    status,
    handleDepositPopup,
    handleRevertPopup,
    isPurchasePayment,
}) => {
    return (
        <div className="cheque-list-card">
            {document_number && (
                <>
                    <div className="first-section">
                        <div className="bill-section">
                            <div className="title">
                                <label>Bill#: </label>
                                <p>{document_number}</p>
                            </div>
                            <div className="circle"></div>
                            {cheque_no && (
                                <div className="title">
                                    <label>Cheque#: </label> <p> {cheque_no}</p>
                                </div>
                            )}
                        </div>

                        {status?.toLowerCase() === "deposit pending" && (
                            <div className="action-section">
                                <Dropdown>
                                    <Dropdown.Toggle
                                        className="dropdown-icon"
                                        id="dropdown-basic"
                                    >
                                        <ThreeDotsIcon />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        {!isPurchasePayment && (
                                            <>
                                                {handleDepositPopup && (
                                                    <Dropdown.Item onClick={handleDepositPopup}>
                                                        <div>
                                                            <span className="icon">
                                                                <DepositIcon />
                                                            </span>
                                                            Deposit
                                                        </div>
                                                    </Dropdown.Item>
                                                )}
                                            </>
                                        )}
                                        <Dropdown.Item onClick={handleRevertPopup}>
                                            <div>
                                                <span className="icon">
                                                    <RevertIcon />
                                                </span>
                                                Revert
                                            </div>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        )}
                        {isPurchasePayment && !status && (
                            <div className="action-section">
                                <Dropdown>
                                    <Dropdown.Toggle
                                        className="dropdown-icon"
                                        id="dropdown-basic"
                                    >
                                        <ThreeDotsIcon />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        {!isPurchasePayment && (
                                            <>
                                                {handleDepositPopup && (
                                                    <Dropdown.Item onClick={handleDepositPopup}>
                                                        <div>
                                                            <span className="icon">
                                                                <DepositIcon />
                                                            </span>
                                                            Deposit
                                                        </div>
                                                    </Dropdown.Item>
                                                )}
                                            </>
                                        )}
                                        <Dropdown.Item onClick={handleRevertPopup}>
                                            <div>
                                                <span className="icon">
                                                    <RevertIcon />
                                                </span>
                                                Revert
                                            </div>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        )}
                    </div>
                    <hr />
                </>
            )}

            <div className="second-section">
                <div className="name-part">
                    <div className="logo">{logo}</div>
                    <div>
                        <div className="name">{name}</div>
                        {address && (
                            <div className="title">
                                <label> Address: </label>
                                <p>{address}</p>
                            </div>
                        )}

                        <div className="title">
                            <label> Mobile No: </label>
                            <p>{mobile}</p>
                        </div>
                    </div>
                </div>
                <div className="amount">
                    Rs.{englishToNepaliAmountConverter(amount)}
                </div>
            </div>
            {document_number && (
                <>
                    <hr />
                    <div className="first-section">
                        <div className="date-section">
                            <CalenderIcon />
                            <p> {miti}</p>
                        </div>
                        {status && (
                            <div className={`status-section ${status.toLowerCase()}`}>
                                {status}
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default ChequeListCard;
